import { createContext, useContext } from 'react';
import { useCurrentDataContext } from './CurrentDataContext';
import { ContextProviderProps } from './interfaces';
import { useOriginalDataContext } from './OriginalDataContext';
import { useUserContext } from './UserContext';
import 'react-toastify/dist/ReactToastify.css';

interface ClearContextsContextType {
    clearContexts: () => void,
};

export const ClearContextsContext = createContext({} as ClearContextsContextType);
export const useClearContextsContext = () => useContext(ClearContextsContext);

export const ClearContextsContextProvider = ({ children }: ContextProviderProps) => {
    const { setUser } = useUserContext();
    const { setCurrentData } = useCurrentDataContext();
    const { setOriginalData } = useOriginalDataContext();

    const clearContexts = () => {
        // Set user context to null
        setUser(null);
        // Clear current and original datas
        setOriginalData(undefined);
        setCurrentData(undefined);
    };

    return <ClearContextsContext.Provider value={{ clearContexts }}>
        {children}
    </ClearContextsContext.Provider>
};